export enum SettlementDocumentRecalculatingTypeEnum {
    DocumentInForeignCurrency = 0,
    DocumentInPlnConvertedWithExchangeRate = 1,
}
